import { Component } from '@angular/core';

@Component({
  selector: 'app-company-policy',
  imports: [],
  templateUrl: './company-policy.html',
  styleUrl: './company-policy.css',
})
export class CompanyPolicy {}
